import { connectedStore } from '../../store';
import getConstraints from '../selectors/constraints';
import isContenteditableRich from '../helpers/is-contenteditable-rich';

const getContentEditableRootSelector = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const constraints = getConstraints(state);
  return constraints.filter(isContenteditableRich).map((constraint) => constraint.element);
};

export default getContentEditableRootSelector;
